import React, {
    ChangeEvent,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react';

import styled from '@emotion/styled';

import { Button } from '../../../components/Button';
import { FieldProps } from 'formik';
import { FormContext } from '../../../modules/Formi/context';

export const InputFile = ({ form, field, meta, ...restProps }: FieldProps) => {
    const { buttonThemeVariant } = useContext(FormContext);
    const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
    const hiddenInputRef = useRef<HTMLInputElement>(null);

    /**
     * This effect is "watching" Formik values and allows us to list selected
     * files or clear the state when `Formik.resetForm()` is used
     */
    useEffect(() => {
        const fileList = form.values[field.name] as FileList;
        setSelectedFiles(Array.from(fileList).map((file) => file.name));
    }, [form.values[field.name]]);

    /**
     * Programatically click the hidden file input element when the Button
     * component is clicked
     */
    const handleClick = () => {
        if (hiddenInputRef.current) hiddenInputRef.current.click();
    };

    /**
     * Custom `onChange` method is needed to make `Formik` work with multiple
     * files. We explicitly set given `field` value as Array.from(files)
     */
    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = event.target.files;

        if (selectedFiles) {
            form.setFieldValue(field.name, Array.from(selectedFiles));
        }
    };

    return (
        <>
            <Input
                ref={hiddenInputRef}
                onChange={(event) => handleOnChange(event)}
                {...restProps}
            />
            <Button onClick={() => handleClick()} variant={buttonThemeVariant}>
                {(restProps as any).label}
            </Button>
            {selectedFiles && (
                <SelectedFilesInformation>
                    <List>
                        {selectedFiles.map((file) => (
                            <li key={file}>{file} </li>
                        ))}
                    </List>
                </SelectedFilesInformation>
            )}
        </>
    );
};

/**
 * Native input is hidden because this element can't be easly styled
 */
const Input = styled.input`
    width: 0;
    height: 0;
    overflow: hidden;
    opacity: 0;
`;

const List = styled.ol`
    list-style: none;
    margin: 20px 0;
    font-size: 0.75em;
`;

const SelectedFilesInformation = styled.div``;
